import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function PolitiqueConfidentialite() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-4xl mx-auto px-6 py-16">
        <button
          onClick={() => navigate('/')}
          className="inline-flex items-center gap-2 text-gray-600 hover:text-gray-900 mb-8 transition-colors"
        >
          <ArrowLeft className="w-5 h-5" />
          Retour à l'accueil
        </button>

        <h1 className="text-4xl font-light text-gray-900 mb-8">Politique de confidentialité</h1>

        <div className="prose prose-lg max-w-none space-y-8">
          <section>
            <p className="text-gray-600 leading-relaxed">
              Date de dernière mise à jour : Octobre 2025
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-normal text-gray-900 mb-4">1. Collecte des données</h2>
            <p className="text-gray-600 leading-relaxed">
              Campaly collecte les données personnelles suivantes :
            </p>
            <ul className="list-disc pl-6 text-gray-600 space-y-2">
              <li>Données d'identification (nom, prénom, email)</li>
              <li>Données de connexion (adresse IP, logs de connexion)</li>
              <li>Données de navigation (pages visitées, durée de visite)</li>
              <li>Données professionnelles (entreprise, fonction)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-normal text-gray-900 mb-4">2. Finalités du traitement</h2>
            <p className="text-gray-600 leading-relaxed">
              Vos données personnelles sont collectées pour les finalités suivantes :
            </p>
            <ul className="list-disc pl-6 text-gray-600 space-y-2">
              <li>Gestion de votre compte utilisateur</li>
              <li>Fourniture des services de la plateforme</li>
              <li>Communication et support client</li>
              <li>Amélioration de nos services</li>
              <li>Respect de nos obligations légales</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-normal text-gray-900 mb-4">3. Base légale du traitement</h2>
            <p className="text-gray-600 leading-relaxed">
              Le traitement de vos données personnelles est fondé sur :
            </p>
            <ul className="list-disc pl-6 text-gray-600 space-y-2">
              <li>L'exécution du contrat de service</li>
              <li>Votre consentement</li>
              <li>Notre intérêt légitime</li>
              <li>Le respect d'obligations légales</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-normal text-gray-900 mb-4">4. Durée de conservation</h2>
            <p className="text-gray-600 leading-relaxed">
              Vos données personnelles sont conservées pendant la durée nécessaire aux finalités pour lesquelles
              elles ont été collectées, et conformément aux obligations légales applicables.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-normal text-gray-900 mb-4">5. Destinataires des données</h2>
            <p className="text-gray-600 leading-relaxed">
              Vos données peuvent être transmises à :
            </p>
            <ul className="list-disc pl-6 text-gray-600 space-y-2">
              <li>Les services internes de Campaly</li>
              <li>Nos prestataires techniques (hébergement, maintenance)</li>
              <li>Les autorités légales sur demande</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-normal text-gray-900 mb-4">6. Vos droits</h2>
            <p className="text-gray-600 leading-relaxed">
              Conformément au RGPD, vous disposez des droits suivants :
            </p>
            <ul className="list-disc pl-6 text-gray-600 space-y-2">
              <li>Droit d'accès à vos données personnelles</li>
              <li>Droit de rectification de vos données</li>
              <li>Droit à l'effacement de vos données</li>
              <li>Droit à la limitation du traitement</li>
              <li>Droit à la portabilité de vos données</li>
              <li>Droit d'opposition au traitement</li>
              <li>Droit de retirer votre consentement</li>
            </ul>
            <p className="text-gray-600 leading-relaxed mt-4">
              Pour exercer ces droits, contactez-nous à : <a href="mailto:contact@campaly.com" className="text-gray-900 underline">contact@campaly.com</a>
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-normal text-gray-900 mb-4">7. Sécurité</h2>
            <p className="text-gray-600 leading-relaxed">
              Nous mettons en œuvre des mesures techniques et organisationnelles appropriées pour protéger
              vos données personnelles contre tout accès non autorisé, modification, divulgation ou destruction.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-normal text-gray-900 mb-4">8. Cookies</h2>
            <p className="text-gray-600 leading-relaxed">
              Notre site utilise des cookies techniques nécessaires à son fonctionnement.
              Ces cookies ne nécessitent pas de consentement préalable.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-normal text-gray-900 mb-4">9. Contact</h2>
            <p className="text-gray-600 leading-relaxed">
              Pour toute question relative à cette politique de confidentialité ou à l'utilisation de vos données :<br />
              <a href="mailto:contact@campaly.com" className="text-gray-900 underline">contact@campaly.com</a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
